import type { TPermission } from '@semios/app-platform-value-type-definitions'
import { isEmpty } from 'lodash'
import { HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD } from 'settings/hubConnectorEnvironment'
import type { TRegionId } from 'stores/fieldAssetStore/helperTypes'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

type RequiresObject = {
  permission: TPermission
  entity: number | TRegionId | '*' | 'FOR_ANY_ENTITY' | 'FOR_ANY_PROPERTY'
}

export type RequiresArg = RequiresObject | RequiresObject[] | boolean

const isEntityAPropertyId = (entity: number | TRegionId | '*' | 'FOR_ANY_ENTITY' | 'FOR_ANY_PROPERTY') =>
  Boolean(Number(entity))

const isSwagworldEnvironmentAndShouldOverrideToDenyPermission = (p: TPermission): boolean => {
  /* eslint-disable padding-line-between-statements */
  if (!HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD) return false
  if (p === 'EDIT_IRRIGATION_PLANNER') return false
  if (p === 'PUBLISH_IRRIGATION_PLANNER_EVENTS_TO_CONTROL_PROVIDER') return false
  if (p.startsWith('EDIT_')) return true
  if (p.startsWith('PUBLISH_')) return true
  if (p === 'VIEW_ALMOND_HULL_SPLIT_SUMMARY') return true
  /* eslint-enable padding-line-between-statements */

  return false
}

export const checkAuthorization = (
  requires: RequiresArg,
  userPermissions = userDetailsStore.getState().permissions,
) => {
  if (typeof requires === 'boolean') return requires

  const requiresArray: RequiresObject[] = [].concat(requires as [])

  return requiresArray.some(({ permission, entity }) => {
    let passes = false

    const permissionArray: TPermission[] = [].concat(permission as unknown as [])

    try {
      passes = permissionArray.some((p) => {
        if (p === 'MOCK_PERMISSION') return true

        if (isSwagworldEnvironmentAndShouldOverrideToDenyPermission(p)) return false

        let hasThisPermission = false

        try {
          if (entity === 'FOR_ANY_PROPERTY') {
            const entityIds = Object.keys(userPermissions[p] ?? {})

            hasThisPermission = entityIds.filter(isEntityAPropertyId).length > 0
          } else if (entity === 'FOR_ANY_ENTITY') {
            hasThisPermission = !isEmpty(userPermissions[p])
          } else {
            hasThisPermission = !isEmpty(userPermissions[p]) && userPermissions[p][entity]
          }
        } catch (err) {}

        return hasThisPermission
      })
    } catch (err) {}

    return passes
  })
}
